import { IDateTimeObject } from './DateTime';
import { IFacility } from './Facility';

export enum CallType  {
  Local = 1,
  InState = 2,
  International = 3,
  OutOfState = 6,
  Global = 7
}

export interface ICall {
  id: number
  duration: number
  date: IDateTimeObject
  charge: number
  cityTax: number
  stateTax: number
  countyTax: number
  fedTax: number
  toStateTax: number
  usfTax: number
  trsTax: number
  fssfTax: number
  facility: IFacility[]
  cdr: { id: number, direction: string }
}

export function getCallTaxes(call: ICall): number {
  return (
    call.cityTax +
    call.countyTax +
    call.stateTax +
    call.toStateTax +
    call.fedTax +
    call.usfTax +
    call.trsTax +
    call.fssfTax
  );
}
